export default __webpack_public_path__ + "static/media/report.1bca44db.svg";